
import { accommodationMapping } from '../mappings/AccommodationMapping';
import { experienceMapping } from '../mappings/ExperienceMapping';
import { locationMapping } from '../mappings/LocationMapping';

export const getUsedTerms = (
  detectedAccommodationType: string | null,
  detectedExperienceType: string | null,
  detectedLocation: any
): string[] => {
  const usedTerms: string[] = [];
  
  if (detectedAccommodationType) {
    usedTerms.push(...accommodationMapping[detectedAccommodationType as keyof typeof accommodationMapping]);
  }
  
  if (detectedExperienceType) {
    usedTerms.push(...experienceMapping[detectedExperienceType as keyof typeof experienceMapping]);
  }
  
  if (detectedLocation) {
    if (detectedLocation.type === 'city') {
      usedTerms.push(...Object.keys(locationMapping.cities).filter(key => 
        locationMapping.cities[key] === detectedLocation.info
      ));
    } else if (detectedLocation.type === 'region') {
      usedTerms.push(...Object.keys(locationMapping.regions).filter(key => 
        locationMapping.regions[key] === detectedLocation.info
      ));
    } else if (detectedLocation.type === 'country') {
      usedTerms.push(...Object.keys(locationMapping.countries).filter(key => 
        locationMapping.countries[key] === detectedLocation.info.country
      ));
    }
  }
  
  return usedTerms;
};

export const applyBroadSearch = (dbQuery: any, searchTerms: string[]) => {
  const searchConditions: string[] = [];
  
  searchTerms.forEach(term => {
    const termLower = term.toLowerCase();
    
    // Voor kust/zee termen: sluit binnenlandse locaties uit
    if (termLower.includes('kust') || termLower.includes('strand') || termLower.includes('zee')) {
      searchConditions.push(
        `name.ilike.%${term}%`,
        `description.ilike.%${term}%`,
        `city.ilike.%${term}%`,
        `country.ilike.%${term}%`,
        `region.ilike.%${term}%`,
        `facilities.ilike.%${term}%`,
        `categoryPath.ilike.%${term}%`,
        `specialCategories.ilike.%${term}%`
      );
    } else if (termLower.includes('meer') || termLower.includes('lake')) {
      // Zoek naar meer-gerelateerde accommodaties
      searchConditions.push(
        `name.ilike.%${term}%`,
        `description.ilike.%${term}%`,
        `city.ilike.%${term}%`,
        `country.ilike.%${term}%`,
        `region.ilike.%${term}%`,
        `facilities.ilike.%${term}%`,
        `categoryPath.ilike.%${term}%`,
        `specialCategories.ilike.%${term}%`
      );
    } else {
      // Algemene zoektermen
      searchConditions.push(
        `name.ilike.%${term}%`,
        `description.ilike.%${term}%`,
        `city.ilike.%${term}%`,
        `country.ilike.%${term}%`,
        `region.ilike.%${term}%`,
        `facilities.ilike.%${term}%`,
        `categoryPath.ilike.%${term}%`,
        `specialCategories.ilike.%${term}%`,
        `typeAccommodatie.ilike.%${term}%`,
        `typeVakantie.ilike.%${term}%`
      );
    }
  });

  if (searchConditions.length > 0) {
    let query = dbQuery.or(searchConditions.join(','));
    
    // Als er kust/zee termen zijn, sluit binnenlandse Nederlandse locaties uit
    const hasCoastalTerms = searchTerms.some(term => {
      const lowerTerm = term.toLowerCase();
      return lowerTerm.includes('kust') || lowerTerm.includes('strand') || lowerTerm.includes('zee');
    });

    if (hasCoastalTerms) {
      const excludeConditions = [
        'description.not.ilike.%meer%',
        'description.not.ilike.%lake%',
        'description.not.ilike.%aan het meer%',
        'name.not.ilike.%meer%',
        'name.not.ilike.%lake%',
        // Exclusief bekende binnenlandse Nederlandse regio's/provincies
        'region.not.ilike.%limburg%',
        'region.not.ilike.%brabant%',
        'region.not.ilike.%gelderland%',
        'region.not.ilike.%utrecht%',
        'region.not.ilike.%overijssel%',
        'region.not.ilike.%drenthe%',
        'region.not.ilike.%flevoland%',
        'city.not.ilike.%maastricht%',
        'city.not.ilike.%eindhoven%',
        'city.not.ilike.%utrecht%',
        'city.not.ilike.%arnhem%',
        'city.not.ilike.%nijmegen%',
        'city.not.ilike.%apeldoorn%',
        'city.not.ilike.%enschede%',
        'city.not.ilike.%zwolle%',
        'city.not.ilike.%deventer%',
        'city.not.ilike.%amersfoort%'
      ];
      
      console.log('Applying coastal exclusions in broad search');
      query = query.and(excludeConditions.join(','));
    }
    
    return query;
  }
  
  return dbQuery;
};

export const validateVacationData = (data: any[]) => {
  return (data || []).map((vacation: any) => ({
    ...vacation,
    name: vacation.name || "Onbekende vakantie",
    imageURL: vacation.imageURL || "/placeholder.svg"
  }));
};
